// This file is AUTOGENERATED, do not edit it manually!!!

export const filters = {
    Activity_Text: 'Actividad',
    ActivityActualBilling: 'Actividad Facturable',
    ActivityActualCompletionDateCondition_Text: 'Fecha real de finalización de la actividad',
    ActivityActualCost: 'Coste Real de Actividad',
    ActivityActualGreaterThanEstimated_Text: 'Actividades subestimadas',
    ActivityActualHours: 'Horas reales de actividad',
    ActivityActualLaborBilling: 'Actividad Laboral Facturable Real ',
    ActivityActualLaborCost: 'Actividad Coste Laboral Real',
    ActivityBilled: 'Actividad Facturada',
    ActivityBilledLabor: 'Actividad Laboral Facturada',
    ActivityBilledPercentage: 'Actividad Facturada, %',
    ActivityBudgetVariance: 'Variación del Presupuesto de Actividades',
    ActivityCreationDateCondition_Text: 'Fecha de creación de actividad',
    ActivityCreator_Text: 'Creadores de actividades',
    ActivityCreatorCondition_Empty_Text: 'Sistema',
    ActivityCreatorCondition_Text: 'Creador de actividad',
    ActivityCustomFieldCondition_Text: 'Actividad Campos Personalizados',
    ActivityDuration: 'Duración de actividad',
    ActivityEACBillableExpenses: 'Actividad EAC Gastos Facturables',
    ActivityEACBilling: 'Actividad EAC Facturable',
    ActivityEACCost: 'Costo de la Actividad EAC',
    ActivityEACExpenses: 'Actividad EAC Gastos',
    ActivityEACLaborBilling: 'Actividad EAC Laboral Facturable',
    ActivityEACLaborCost: 'Actividad EAC Coste Laboral',
    ActivityEACNonBillableExpenses: 'Actividad EAC Gastos No Facturables',
    ActivityEndDateCondition_Text: 'Fecha de finalización de actividad',
    ActivityEstimatedExpensesAmount: 'Gastos de Actividad ETC',
    ActivityEstimatedExpensesBillableAmount: 'Actividad ETC Gastos Facturables',
    ActivityEstimatedExpensesNonBillableAmount: 'Actividad ETC Gastos No Facturables',
    ActivityEstimatedHours: 'Horas estimadas de actividad',
    ActivityETCBilling: 'Actividad ETC Facturable',
    ActivityETCCost: 'Costo de Actividad ETC',
    ActivityETCLaborBilling: 'Actividad ETC Laboral Facturable',
    ActivityETCLaborCost: 'Actividad ETC Costo Laboral',
    ActivityExpectedProfit: 'Actividad Beneficio Esperado',
    ActivityExpectedProfitPercentage: 'Actividad Beneficio Esperado, %',
    ActivityExpensesAmount: 'Gastos Reales de Actividad',
    ActivityExpensesBillableAmount: 'Gastos Facturables Reales de Actividad',
    ActivityExpensesBilledAmount: 'Gastos Facturados por Actividad',
    ActivityExpensesNonBillableAmount: 'Gastos Reales No Facturables de Actividad',
    ActivityHealthCondition_Text: 'Salud de la actividad',
    ActivityHealthTypes: 'Salud de la actividad',
    ActivityIsMilestone: 'La actividad Es un Hito',
    ActivityProcessCondition_Text: 'Progreso de actividad',
    ActivityProfit: 'Beneficio de Actividad',
    ActivityProfitPercentage: 'Beneficio de Actividad, %',
    ActivityProgress_Text: 'Progreso de actividad',
    ActivityStartDateCondition_Text: 'Fecha de comienzo de actividad',
    ActivityStatusCondition_Text: 'Estado de actividad',
    ActivityTotalBudget: 'Presupuesto Total de la Actividad',
    ActivityTypeCondition_Text: 'Tipo de actividad:',
    ActivityTypes_Issue: 'Asunto',
    ActivityTypes_Request: 'Solicitud',
    ActivityTypes_Task: 'Tarea',
    ActivityTypesCondition_Text: 'Tipos de actividad',
    ActualCompletionDate_Text: 'Fecha de finalización real',
    add_filters: 'Añadir filtros',
    AdvancedFilterTooltipContent_Text: 'Haga clic aquí para ver todas las opciones de filtrado posibles',
    AdvancedFilterTooltipTitle_Text: 'Filtros avanzados',
    AllActivities_Text: 'Actividad',
    Apply_Text: 'Aplicar',
    AssigneeCondition_Text: 'Personas asignadas',
    AssigneeOption_Text: 'Personas asignadas',
    AssigneeTeamCondition_Entity: 'equipos',
    AssigneeUserCondition_Empty_Text: 'No cesionarios',
    AssigneeUserCondition_Entity: 'personas asignadas',
    BoolCustomField_No_Text: 'No',
    BoolCustomField_NotSelected_Text: 'No seleccionado',
    BoolCustomField_Yes_Text: 'Sí',
    BudgetAndCosts_Filters_Group: 'Presupuesto y Costes',
    CategoriesCondition_Text: 'Categorías',
    CategoryCondition_Empty_Text: 'Sin categoría',
    CategoryCondition_Entity: 'categorías',
    CategoryCondition_Text: 'Categoría',
    Clear_All_Text: 'Limpiar todos los filtros',
    CompletedStatus_Text: 'Completo',
    ContainMore_Text: 'Hay más resultados, sigue escribiendo...',
    CreationDate_Text: 'Fecha de creación',
    CustomerCondition_Empty_Text: 'No hay cliente',
    CustomerCondition_Entity: 'clientes',
    CustomerCondition_Text: 'Clientes',
    CustomFieldsFilters_Group: 'Campos personalizados',
    DraftCondition_Text: 'Borradores',
    DraftStatus_Text: 'Borradores',
    EndDate_Text: 'Fecha de finalización',
    FilterByKeyword_Text: 'Filtrar por palabra clave',
    FilterByPeriod_Text: 'Filtrar por periodo',
    FilterByTimeframe_Text: 'Filtrar por período de tiempo',
    FilterTabs_Tab1: 'Estado',
    FilterTabs_Tab2: 'Recursos & Limitaciones',
    FilterTabs_Tab3: 'Salud & Progreso',
    FilterTabs_Tab4: 'Proyectos, Clientes & más',
    FilterTabs_Tab5: 'Campos Personalizados',
    Followed: 'Seguir',
    FollowedByMe_Text: 'Actividades seguidas por mí',
    From_Text: 'de',
    general: 'General',
    HealthCondition_Text: 'Salud',
    HealthItemType_Bad: 'Problema',
    HealthItemType_Good: 'Bien',
    HealthItemType_Medium: 'En riesgo',
    HealthItemType_NotCalculated: 'No calculado',
    HealthTooltip_Text: 'La salud es un índice calculado que muestra qué tan bien va un proyecto o actividad',
    HealthTooltipLink_Text: 'Vea más en nuestra ayuda en línea',
    HoursCondition_Text: 'Tiempo',
    HoursFilters_Group: 'Tiempo',
    HoursLeft: 'Horas restantes',
    InProgressStatus_Text: 'En Curso',
    InThePast: 'Antiguamente',
    InvalidDate: 'La fecha debe estar en \'{0}\' formato.',
    Issue_Text: 'Asunto',
    KeepTyping_Text: 'Sigue escribiendo...',
    ListCustomFieldCondition_Empty_Text: 'No seleccionado',
    ManualRange: 'Intervalo de fechas especificado...',
    Me: 'Yo',
    Menu_Dates: 'Fechas',
    Milestone_Text: 'Hito',
    MoneyCondition_Text: 'Dinero',
    More_Text: 'Mas',
    MultiSelectCustomFieldCondition_Empty_Text: 'No seleccionado',
    NextMonth: 'Mes siguiente',
    NextWeek: 'Semana siguiente',
    no_filters: 'Sin filtros para mostrar',
    NoCategory: 'Sin categoría',
    NoMatch_Text: 'Lo sentimos, no se encontró nada',
    OnHoldStatus_Text: 'En espera',
    PeopleCondition_Text: 'Personas',
    PinTooltip_Text: 'Pin',
    Portfolio_Status_Text: 'Pestado de portafolio',
    PortfolioCondition_Empty_Text: 'Sin cartera',
    PortfolioCondition_Entity: 'cartera',
    PortfolioCondition_Text: 'Portafolios',
    PortfolioCreator_Text: 'Creadores de portafolios',
    PortfolioCreatorCondition_Text: 'Creador de portafolio',
    PortfolioManager_Text: 'Gestores de portafolio',
    PortfolioManagerCondition_Text: 'Gestor de portafolio',
    PreviousMonth: 'Mes anterior',
    PreviousWeek: 'Semana anterior',
    PreviousYear: 'Año anterior',
    PriorityCondition_Text: 'Prioridades',
    Progress_Filters_Group: 'Progreso',
    ProgressCondition_Entity: 'Progreso: ',
    ProgressCondition_Text: 'Progreso',
    Project_Text: 'Proyecto',
    ProjectActualBilling: 'Proyecto Facturable',
    ProjectActualCompletionDateCondition_Text: 'Fecha real de finalización del proyecto',
    ProjectActualCost: 'Costo Real del Proyecto',
    ProjectActualGreaterThanEstimated_Text: 'Proyectos subestimados',
    ProjectActualHours: 'Horas reales del proyecto',
    ProjectActualLaborBilling: 'Mano de Obra Facturable Real del Proyecto',
    ProjectActualLaborCost: 'Costo Laboral Real del Proyecto',
    ProjectBilled: 'Proyecto Facturado',
    ProjectBilledLabor: 'Mano de Obra Facturada por Proyecto',
    ProjectBilledPercentage: 'Proyecto Facturado, %',
    ProjectBudgetVariance: 'Variación del Presupuesto del Proyecto',
    ProjectCondition_EmptyText: 'No se ha seleccionado ningún proyecto',
    ProjectCondition_Entity: 'proyectos',
    ProjectCondition_Text: 'Proyectos',
    ProjectCostExceedBudget_Text: 'Proyectos sobre presupuestados',
    ProjectCreationDateCondition_Text: 'Fecha de creación del proyecto',
    ProjectCreator_Text: 'Creadores de proyectos',
    ProjectCreatorCondition_Text: 'Creador de proyecto',
    ProjectCustomFieldCondition_Text: 'Campos Personalizados del Proyecto',
    ProjectDuration: 'Duración del proyecto',
    ProjectEACBillableExpenses: 'Gastos Facturables del Proyecto EAC',
    ProjectEACBilling: 'Proyecto EAC Facturable',
    ProjectEACCost: 'Costo del Proyecto EAC',
    ProjectEACExpenses: 'Proyecto EAC Gastos',
    ProjectEACLaborBilling: 'Proyecto EAC Mano de Obra Facturable',
    ProjectEACLaborCost: 'Costo de Mano de Obra del Proyecto EAC',
    ProjectEACNonBillableExpenses: 'Gastos No facturables del Proyecto EAC',
    ProjectEndDateCondition_Text: 'Fecha final proyecto',
    ProjectEstimatedExpensesAmount: 'Gastos ETC del Proyecto',
    ProjectEstimatedExpensesBillableAmount: 'Gastos Facturables del Proyecto ETC',
    ProjectEstimatedExpensesNonBillableAmount: 'Gastos No facturables del Proyecto ETC',
    ProjectEstimatedHours: 'Horas estimadas del proyecto',
    ProjectETCBilling: 'Proyecto ETC Facturable',
    ProjectETCCost: 'Costo del Proyecto ETC',
    ProjectETCLaborBilling: 'Proyecto ETC Mano de Obra Facturable',
    ProjectETCLaborCost: 'Coste Laboral del Proyecto ETC',
    ProjectExpectedProfit: 'Beneficio Esperado del Proyecto',
    ProjectExpectedProfitPercentage: 'Beneficio Esperado del Proyecto, %',
    ProjectExpensesAmount: 'Gastos Reales del Proyecto',
    ProjectExpensesBillableAmount: 'Gastos Facturables Reales del Proyecto',
    ProjectExpensesBilledAmount: 'Gastos Facturados del Proyecto',
    ProjectExpensesNonBillableAmount: 'Gastos Reales No Facturables del Proyecto',
    ProjectHealthCondition_Text: 'Salud del proyecto',
    ProjectHealthTypes: 'Salud del proyecto',
    ProjectManager_Text: 'Gestores de proyecto',
    ProjectManagerCondition_Text: 'Gestor de proyectos',
    ProjectMemberCondition_Text: 'Miembro del proyecto',
    ProjectPriorityCondition_Text: 'Prioridad de proyecto',
    ProjectPriorityCondition_Text_Template: 'Proyectos con %s prioridad',
    ProjectProcessCondition_Text: 'Progreso de proyecto',
    ProjectProfit: 'Beneficio del Proyecto',
    ProjectProfit_Text: 'Proyectos con pérdidas financieras',
    ProjectProfitPercentage: 'Beneficio del Proyecto, %',
    ProjectProgress_Text: 'Progreso de proyecto',
    ProjectsAndTasksList_Title: 'Proyectos y tareas',
    ProjectsCustomersAndMore_Filters_Group: 'Proyectos, Clientes & más',
    ProjectStartDateCondition_Text: 'Fecha de comienzo del proyecto',
    ProjectStatusCondition_Text: 'Estado del proyecto',
    ProjectTotalBudget: 'Presupuesto Total del Proyecto',
    QuickFilterWatermark: 'Filtrar por...',
    range_condition_text: 'Rango',
    Request_Text: 'Solicitud',
    ResourcesAndConstraints_Filters_Group: 'Recursos & Limitaciones',
    roles_condition_text: 'Roles',
    RollBack_Text: 'Volver a los filtros anteriores',
    SaveFilters_Title: 'Filtros guardados',
    set_filters: 'Establecer filtros usando el',
    set_filters_part2: 'icono',
    skills_condition_text: 'Aptitudes',
    StartDate_Text: 'Fecha de comienzo',
    Statuses_Filters_Group: 'Estado',
    StatusesCountFormat: '1#{0}estado# {0}estados',
    Task_Text: 'Tarea',
    TaskCondition_Entity: 'actividades',
    TaskCondition_Text: 'Actividad',
    TaskCostExceedBudget_Text: 'Las actividades sobrepresupuestados',
    TaskPriorityCondition_Entity: 'prioridades de actividad',
    TaskPriorityCondition_Text: 'Prioridad de actividad',
    TaskPriorityCondition_Text_Template: 'Actividades con %s prioridad',
    TasksAssignedToMilestone_Text: 'Actividad asignada a hito',
    teams_condition_text: 'Equipos',
    TemplateCondition_Text: 'Plantillas',
    TemplateStatus_Text: 'Plantillas',
    ThisMonth: 'Este mes',
    ThisWeek: 'Esta semana',
    ThisYear: 'Este año',
    To_Text: 'a',
    Today: 'Hoy',
    TypesCondition_Text: 'Tipos',
    UnpinTooltip_Text: 'Desanclar',
    users_condition_text: 'Usuarios',
    Yesterday: 'Ayer',
};
